"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _params = require("./params.js");
var _react2 = require("./react.js");
var QuestionsFilterHooks = /*#__PURE__*/_createClass(function QuestionsFilterHooks(Algolia, Config) {
  var _this = this;
  _classCallCheck(this, QuestionsFilterHooks);
  this.initialState = {
    selectedDifficulty: [],
    selectedSubjectRiskCategories: [],
    keywordFilteredIds: new Set(),
    keywordFilter: '',
    filterMarked: false,
    selectedStatus: '',
    selectedSubjects: [],
    allStatuses: [],
    unanswered: [],
    incorrect: [],
    correct: [],
    unseen: [],
    marked: [],
    allDifficulties: [],
    hard: [],
    moderate: [],
    easy: [],
    allSubjectRiskCategories: [],
    atRisk: [],
    needsImprovement: [],
    onTrack: [],
    notEnoughData: [],
    questionsBySubject: {},
    results: [],
    searchStatus: null,
    resultsValid: true,
    allSubjects: 1,
    questionIds: [],
    filterQuizType: '',
    selectedQuestionType: 'all',
    all: [],
    traditional: [],
    nextGen: [],
    isNgnEnabled: false,
    tutorModeSelected: false,
    nextGenSelected: false
  };
  this.Algolia = Algolia;
  this.Config = Config;
  this.reducer = function (state, action) {
    var type = action.type,
      payload = action.payload;
    if (_this.Config.contextReducerLogging) {
      console.log('%c%s', 'color: yellow; background: green;', type, payload);
    }
    switch (type) {
      case "SET_FORM_FROM_SEARCH":
        return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
          allSubjects: 0
        });
      case "SET_QUIZ_TYPE":
        return _objectSpread(_objectSpread({}, state), {}, {
          filterQuizType: payload.filterQuizType
        });
      case "SET_DIFFICULTY_LEVELS":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDifficulty: _toConsumableArray(payload.selectedDifficulty)
        });
      case "SET_QUESTION_TYPES":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedQuestionType: payload.selectedQuestionType,
          tutorModeSelected: payload.tutorModeSelected,
          nextGenSelected: payload.nextGenSelected
        });
      case "SET_TUTOR_MODE_SELECTED":
        return _objectSpread(_objectSpread({}, state), {}, {
          tutorModeSelected: payload.tutorModeSelected
        });
      case "SET_DIFFICULTY_QUESTIONS":
        return _objectSpread(_objectSpread({}, state), {}, {
          easy: _toConsumableArray(payload.easy),
          moderate: _toConsumableArray(payload.moderate),
          hard: _toConsumableArray(payload.hard),
          allDifficulties: _toConsumableArray(payload.allDifficulties)
        });
      case "CLEAR_RISK_CATEGORIES":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedSubjectRiskCategories: []
        });
      case "SET_RISK_CATEGORIES":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedSubjectRiskCategories: _toConsumableArray(payload.riskCategories)
        });
      case "SET_TYPE_QUESTIONS":
        return _objectSpread(_objectSpread({}, state), {}, {
          all: _toConsumableArray(payload.all),
          traditional: _toConsumableArray(payload.traditional),
          nextGen: _toConsumableArray(payload.nextGen)
        });
      case "SET_SUBJECT_QUESTIONS":
        return _objectSpread(_objectSpread({}, state), {}, {
          questionsBySubject: _objectSpread({}, payload.questionsBySubject),
          selectedSubjects: payload.selectedSubjects
        });
      case "SET_QUESTION_STATUS":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedStatus: payload.selectedStatus,
          selectedQuestionType: 'all'
        });
      case "SET_STATUS_QUESTIONS":
        return _objectSpread(_objectSpread({}, state), payload);
      case "SET_KEYWORD_FILTER":
        return _objectSpread(_objectSpread({}, state), {}, {
          keywordFilter: payload.keywordFilter
        });
      case "SET_KEYWORD_FILTERED_IDS":
        return _objectSpread(_objectSpread({}, state), {}, {
          keywordFilteredIds: payload.keywordFilteredIds
        });
      case "SET_ALL_SUBJECTS":
        return _objectSpread(_objectSpread({}, state), {}, {
          allSubjects: payload.allSubjects
        });
      case "SET_SELECTED_SUBJECTS":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedSubjects: _toConsumableArray(payload.selectedSubjects)
        });
      case "SET_FILTER_MARKED":
        return _objectSpread(_objectSpread({}, state), {}, {
          filterMarked: payload.filterMarked
        });
      case "SET_QUESTION_IDS":
        return _objectSpread(_objectSpread({}, state), {}, {
          questionIds: payload.questionIds.split(',').map(function (id) {
            return id.trim();
          })
        });
      case "SET_RESULTS":
        return _objectSpread(_objectSpread({}, state), {}, {
          results: _toConsumableArray(payload.results)
        });
      case "CLEAR_SELECTED_STATUS":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedStatus: ''
        });
      case "REMOVE_SELECTED_DIFFICULTY":
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDifficulty: state.selectedDifficulty.filter(function (diff) {
            return diff !== payload.difficulty;
          })
        });
      case "CLEAR_KEYWORD_FILTER":
        return _objectSpread(_objectSpread({}, state), {}, {
          keywordFilter: ''
        });
      case "CLEAR_ALL_FILTERS":
        return _objectSpread(_objectSpread({}, state), {}, {
          keywordFilter: '',
          selectedDifficulty: [],
          selectedStatus: '',
          selectedSubjects: [],
          filterMarked: false,
          questionIds: [],
          selectedSubjectRiskCategories: []
        });
      case "INVALIDATE_RESULTS":
        return _objectSpread(_objectSpread({}, state), {}, {
          resultsValid: false
        });
      case "VALIDATE_RESULTS":
        return _objectSpread(_objectSpread({}, state), {}, {
          resultsValid: true
        });
      default:
        return state;
    }
  };
  this.useQuestionFilter = function (_ref) {
    var isSearch = _ref.isSearch,
      selectedQuestionBankId = _ref.selectedQuestionBankId,
      markedQuestionIds = _ref.markedQuestionIds,
      availableQuestions = _ref.availableQuestions,
      subjects = _ref.subjects,
      _ref$ngnOn = _ref.ngnOn,
      ngnOn = _ref$ngnOn === void 0 ? false : _ref$ngnOn;
    var _ref2 = (0, _react.useReducer)(_this.reducer, _this.initialState),
      _ref3 = _slicedToArray(_ref2, 2),
      state = _ref3[0],
      dispatch = _ref3[1];
    var searchParams = (0, _params.useSearchParams)();
    var selectedDifficulty = state.selectedDifficulty,
      selectedStatus = state.selectedStatus,
      keywordFilteredIds = state.keywordFilteredIds,
      keywordFilter = state.keywordFilter,
      filterQuizType = state.filterQuizType,
      selectedSubjects = state.selectedSubjects,
      filterMarked = state.filterMarked,
      allSubjects = state.allSubjects,
      questionIds = state.questionIds,
      selectedQuestionType = state.selectedQuestionType,
      selectedSubjectRiskCategories = state.selectedSubjectRiskCategories;
    var hasSubject = function hasSubject(subId) {
      return !!subjects.get(subId);
    };
    var filterQuestionsByKeyword = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(keywordFilterState, subjectsState, selectedQuestionBankIdState, passedKeyword) {
        var keyword, subjectIds, algoliaQids, filteredIds;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                keyword = passedKeyword ? passedKeyword.trim() : keywordFilterState.trim();
                subjectIds = subjectsState.keySeq().toArray();
                _context.next = 5;
                return _this.Algolia.algoliaQuestionSearch(keyword, selectedQuestionBankIdState, subjectIds);
              case 5:
                algoliaQids = _context.sent;
                filteredIds = algoliaQids || new Set();
                if (!passedKeyword) {
                  _context.next = 9;
                  break;
                }
                return _context.abrupt("return", filteredIds);
              case 9:
                dispatch({
                  type: 'SET_KEYWORD_FILTERED_IDS',
                  payload: {
                    keywordFilteredIds: filteredIds
                  }
                });
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));
      return function filterQuestionsByKeyword(_x2, _x3, _x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }();
    var debounceFilterByKeyword = (0, _react.useCallback)((0, _react2.debounceFunction)(filterQuestionsByKeyword, 1000), []);
    (0, _react2.useDidUpdateEffect)(function () {
      debounceFilterByKeyword(keywordFilter, subjects, selectedQuestionBankId);
    }, [keywordFilter]);

    // If initialized, alter form if search params present
    var setFormFromSearchParams = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var payload, _iterator, _step, _ref8, _ref7, key, value;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!searchParams || !searchParams.toString())) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                payload = {};
                _iterator = _createForOfIteratorHelper(searchParams.entries());
                _context2.prev = 4;
                _iterator.s();
              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 27;
                  break;
                }
                _ref8 = _step.value;
                _ref7 = _slicedToArray(_ref8, 2);
                key = _ref7[0];
                value = _ref7[1];
                if (key === 'subjectIds') {
                  payload = _objectSpread(_objectSpread({}, payload), {}, {
                    selectedSubjects: value.split(',').map(function (id) {
                      return parseInt(id);
                    }).filter(hasSubject)
                  });
                }
                if (key === 'questionStatus') payload = _objectSpread(_objectSpread({}, payload), {}, {
                  selectedStatus: value
                });
                if (!(key === 'keywordFilter')) {
                  _context2.next = 23;
                  break;
                }
                _context2.t0 = _objectSpread;
                _context2.t1 = _objectSpread({}, payload);
                _context2.t2 = {};
                _context2.t3 = value;
                _context2.next = 20;
                return filterQuestionsByKeyword(keywordFilter, subjects, selectedQuestionBankId, value);
              case 20:
                _context2.t4 = _context2.sent;
                _context2.t5 = {
                  keywordFilter: _context2.t3,
                  keywordFilteredIds: _context2.t4
                };
                payload = (0, _context2.t0)(_context2.t1, _context2.t2, _context2.t5);
              case 23:
                if (key === 'difficultyLevel') payload = _objectSpread(_objectSpread({}, payload), {}, {
                  selectedDifficulty: value.split(',')
                });
                if (key === 'marked') payload = _objectSpread(_objectSpread({}, payload), {}, {
                  filterMarked: value === 'true'
                }); // IDK if we will ever pass "False" but just incase
              case 25:
                _context2.next = 6;
                break;
              case 27:
                _context2.next = 32;
                break;
              case 29:
                _context2.prev = 29;
                _context2.t6 = _context2["catch"](4);
                _iterator.e(_context2.t6);
              case 32:
                _context2.prev = 32;
                _iterator.f();
                return _context2.finish(32);
              case 35:
                dispatch({
                  type: "SET_FORM_FROM_SEARCH",
                  payload: payload
                });
              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 29, 32, 35]]);
      }));
      return function setFormFromSearchParams() {
        return _ref5.apply(this, arguments);
      };
    }();
    (0, _react2.useDidUpdateEffect)(function () {
      setFormFromSearchParams();
    }, [searchParams]);
    (0, _react2.useDidUpdateEffect)(function () {
      if (!isSearch) return;
      dispatch({
        type: 'INVALIDATE_RESULTS'
      });
    }, [selectedStatus, selectedDifficulty, keywordFilter, selectedSubjects, filterMarked]);
    var allowCaseQuestion = function allowCaseQuestion(groupId, ngnType) {
      return !ngnType && filterQuizType === 'adaptive' ? !groupId : true;
    };
    var isAvailableStatus = function isAvailableStatus(question, filterStatus) {
      return question.status === filterStatus;
    };
    var unseenAvailable = function unseenAvailable(question) {
      return !question.seen;
    };
    var isMarked = function isMarked(_ref9) {
      var id = _ref9.id;
      return markedQuestionIds.includes(id);
    };
    var hasAvailableDifficulty = function hasAvailableDifficulty(difficulty) {
      return !selectedDifficulty.length || selectedDifficulty.includes(difficulty);
    };
    var passesNgnOn = function passesNgnOn(ngnType) {
      return ngnOn || !ngnType;
    };
    var passesQuestionTypeFilter = function passesQuestionTypeFilter(ngnType) {
      return passesNgnOn(ngnType) && (selectedQuestionType === 'all' || (ngnType ? selectedQuestionType === 'nextGen' : selectedQuestionType === 'traditional'));
    };
    var passesKeywordFilter = function passesKeywordFilter(id) {
      return keywordFilter.length < 3 || (keywordFilteredIds === null || keywordFilteredIds === void 0 ? void 0 : keywordFilteredIds.has(id));
    };
    var passesMarkFilter = function passesMarkFilter(id) {
      return !filterMarked || isMarked({
        id: id
      });
    };
    var passesInitialFilters = function passesInitialFilters(_ref10) {
      var id = _ref10.id,
        ngnType = _ref10.ngnType,
        groupId = _ref10.groupId;
      return passesKeywordFilter(id) && passesMarkFilter(id) && passesNgnOn(ngnType) && allowCaseQuestion(groupId, ngnType);
    };
    var isAvailable = function isAvailable(_ref11) {
      var seen = _ref11.seen,
        status = _ref11.status;
      return !selectedStatus || selectedStatus.toLowerCase() === status || selectedStatus === 'Unseen' && !seen;
    };
    var matchQuestionType = function matchQuestionType(ngnType) {
      return isSearch || passesQuestionTypeFilter(ngnType);
    };
    var matchesDifficulty = function matchesDifficulty(_ref12, filterDifficulty) {
      var difficulty = _ref12.difficulty_level;
      return !filterDifficulty || difficulty === filterDifficulty;
    };
    var isAvailableDifficulty = function isAvailableDifficulty(question, filterDifficulty) {
      return isAvailable(question) && matchesDifficulty(question, filterDifficulty) && matchQuestionType(question.ngnType);
    };
    var isAvailableQuestionType = function isAvailableQuestionType(question, filterQuestionType) {
      return isAvailable(question) && (!filterQuestionType || (filterQuestionType === 'traditional' ? !question.ngnType : question.ngnType));
    };
    var toAvailableSubjects = function toAvailableSubjects(acc, question) {
      if (isAvailable(question) && hasAvailableDifficulty(question.difficulty_level) && matchQuestionType(question.ngnType)) {
        question.subject_ids.forEach(function (subId) {
          acc[subId] = [].concat(_toConsumableArray(acc[subId] ? acc[subId] : []), [_objectSpread({}, question)]);
        });
      }
      return _objectSpread({}, acc);
    };

    // If it is a search than no subjects means all subjects if it is a create quiz than no means no.
    var passesAllSelections = function passesAllSelections(question) {
      return passesInitialFilters(question) && isAvailable(question) && hasAvailableDifficulty(question.difficulty_level) && matchQuestionType(question.ngnType) && (isSearch && selectedSubjects.length === 0 || selectedSubjects.some(function (subjectId) {
        return question.subject_ids.includes(subjectId);
      }));
    };
    (0, _react.useEffect)(function () {
      var keywordFilteredQs = availableQuestions.filter(passesInitialFilters);
      dispatch({
        type: 'SET_STATUS_QUESTIONS',
        payload: {
          unanswered: keywordFilteredQs.filter(function (q) {
            return isAvailableStatus(q, 'unanswered');
          }),
          incorrect: keywordFilteredQs.filter(function (q) {
            return isAvailableStatus(q, 'incorrect');
          }),
          correct: keywordFilteredQs.filter(function (q) {
            return isAvailableStatus(q, 'correct');
          }),
          unseen: keywordFilteredQs.filter(function (q) {
            return unseenAvailable(q);
          }),
          marked: keywordFilteredQs.filter(isMarked),
          allStatuses: keywordFilteredQs
        }
      });
    }, [availableQuestions, keywordFilteredIds, filterMarked, ngnOn, filterQuizType]);
    (0, _react.useEffect)(function () {
      var keywordFilteredQs = availableQuestions.filter(passesInitialFilters);
      dispatch({
        type: 'SET_DIFFICULTY_QUESTIONS',
        payload: {
          easy: keywordFilteredQs.filter(function (q) {
            return isAvailableDifficulty(q, 'easy');
          }),
          moderate: keywordFilteredQs.filter(function (q) {
            return isAvailableDifficulty(q, 'moderate');
          }),
          hard: keywordFilteredQs.filter(function (q) {
            return isAvailableDifficulty(q, 'hard');
          }),
          allDifficulties: keywordFilteredQs.filter(function (q) {
            return isAvailableDifficulty(q, '');
          })
        }
      });
    }, [availableQuestions, selectedStatus, filterMarked, keywordFilteredIds, ngnOn, selectedQuestionType, filterQuizType]);
    (0, _react.useEffect)(function () {
      var keywordFilteredQs = availableQuestions.filter(passesInitialFilters);
      dispatch({
        type: 'SET_TYPE_QUESTIONS',
        payload: {
          all: keywordFilteredQs.filter(function (q) {
            return isAvailableQuestionType(q, '');
          }),
          traditional: keywordFilteredQs.filter(function (q) {
            return isAvailableQuestionType(q, 'traditional');
          }),
          nextGen: keywordFilteredQs.filter(function (q) {
            return isAvailableQuestionType(q, 'nextGen');
          })
        }
      });
    }, [availableQuestions, selectedStatus, filterMarked, keywordFilteredIds, ngnOn, filterQuizType]);
    (0, _react.useEffect)(function () {
      var keywordFilteredQs = availableQuestions.filter(passesInitialFilters);
      var questionsBySubject = keywordFilteredQs.reduce(toAvailableSubjects, {});
      var newselection = !allSubjects || isSearch ? selectedSubjects.filter(function (subject) {
        return questionsBySubject[subject];
      }) : Object.keys(questionsBySubject).map(function (id) {
        return parseInt(id);
      }).filter(function (id) {
        return questionsBySubject[id];
      });
      dispatch({
        type: 'SET_SUBJECT_QUESTIONS',
        payload: {
          questionsBySubject: questionsBySubject,
          selectedSubjects: newselection
        }
      });
    }, [selectedDifficulty, selectedQuestionType, filterMarked, keywordFilteredIds, selectedStatus, ngnOn, selectedSubjectRiskCategories, filterQuizType]);
    (0, _react2.useDidUpdateEffect)(function () {
      if (questionIds !== null && questionIds !== void 0 && questionIds.some(function (id) {
        return id;
      })) {
        dispatch({
          type: 'SET_RESULTS',
          payload: {
            results: availableQuestions.filter(function (question) {
              return questionIds.includes(question.id.toString());
            })
          }
        });
      } else {
        dispatch({
          type: 'SET_RESULTS',
          payload: {
            results: availableQuestions.filter(passesAllSelections)
          }
        });
      }
    }, [availableQuestions, selectedDifficulty, selectedQuestionType, filterMarked, keywordFilteredIds, selectedSubjects, selectedStatus, questionIds, ngnOn, filterQuizType]);
    return {
      state: state,
      dispatch: dispatch
    };
  };
});
var _default = exports.default = QuestionsFilterHooks;